import { type Attachment } from '../domain/Shipment'
import { AttachmentItem } from './AttachmentItem'
import { DocumentSection } from './DocumentSection/DocumentSection'

export type AttachmentsProps = Readonly<{
  attachments: Attachment[]
  quoteUuid: string
  rateUuid: string
}>

export function Attachments({ attachments, quoteUuid, rateUuid }: AttachmentsProps) {
  if (attachments.length === 0) {
    return null
  }

  return (
    <DocumentSection name="others" key="others">
      {attachments.map(attachment => (
        <AttachmentItem
          key={attachment.id}
          attachment={attachment}
          quoteUuid={quoteUuid}
          rateUuid={rateUuid}
        />
      ))}
    </DocumentSection>
  )
}
